import React from 'react';
import { Button, ButtonPriority as PRIORITY, Spinner, HoverStyles } from 'wix-ui-tpa/cssVars';
import { SPINNER } from '../../../common/constants/data-hooks';
import TextExtended from '../text-extended/text-extended';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { st, classes } from './load-more.st.css';
export const LoadMore = ({ text, onClick, className, isPending = false, dataHook, icon }) => {
    const { screenshotMode } = useConfiguration();
    return (React.createElement(Button, { className: st(classes.root, className), onClick: onClick && onClick, priority: PRIORITY.secondary, "data-hook": dataHook, upgrade: true, hoverStyle: HoverStyles.underline },
        React.createElement(TextExtended, { typography: "buttonSecondary", priority: "buttonSecondary" }, text),
        icon ? icon : null,
        isPending ? (React.createElement(Spinner, { className: classes.spinnerRoot, "data-hook": SPINNER, diameter: 17, isStatic: screenshotMode })) : (React.createElement("div", { className: classes.spinnerPlaceholder }))));
};
//# sourceMappingURL=load-more.js.map